import { Alert, Form } from 'antd';
import warning from '@src/assets/icons/icon-profil-warning.svg';
import {
  CustomButton,
  CustomCheckbox,
  CustomForm,
  CustomFormItem,
  CustomImage,
  Text,
} from '@src/components';
import {useCallback, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { personalDataProtectionLaw } from '@src/utils/keys';

const CommunicationPreferences = ({ handleUpdate }) => {
  const { currentUser } = useSelector((state) => state?.user);

  const [form] = Form.useForm();

  const onFinish = useCallback(
    async (values) => {
      try {
        handleUpdate({
          id: currentUser?.id,
          ContactBySMS: values?.ContactBySMS,
          contactByMail: values?.contactByMail,
          contactByCall: values?.contactByCall,
        });
      } catch (error) {}
    },
    [currentUser, handleUpdate],
  );

  const onCancel = useCallback(() => {
    form.setFieldsValue({
      ContactBySMS: currentUser?.ContactBySMS,
      contactByMail: currentUser?.contactByMail,
      contactByCall: currentUser?.contactByCall,
    });
  }, [currentUser, form]);

  useEffect(() => {
    form.setFieldsValue({
      ContactBySMS: currentUser?.ContactBySMS,
      contactByMail: currentUser?.contactByMail,
      contactByCall: currentUser?.contactByCall,
    });
  }, [currentUser])

  return (
    <div>
      <div className="header-content">
        <h4>
          {' '}
          <Text t="communicationPreferences" />
        </h4>
      </div>

      <div className="personal-information-form">
        <Alert
          message={
            <div className="alert-message-contain">
              <CustomImage src={warning} />{' '}
              <span>
                <Text t="communicationPrefAlertMessage" />
                <br />
                <Text t="communicationPrefAlertMessage2" />
              </span>
            </div>
          }
          banner
          showIcon={false}
          className="custom-alert-warning"
          closable
        />

        <div className="personal-form communication-form">
          <CustomForm
            name="communicationPreferences"
            onFinish={onFinish}
            form={form}
            initialValues={{
              ContactBySMS: currentUser?.ContactBySMS,
              contactByMail: currentUser?.contactByMail,
              contactByCall: currentUser?.contactByCall,
            }}
            awaitLoading={!currentUser?.id}
            autoComplete="off"
            layout={'vertical'}
          >
            <div className="row ">
              <div className="col-md-12">
                <CustomFormItem
                  label={false}
                  name="ContactBySMS"
                  className="custom-form-item"
                  valuePropName="checked"
                >
                  <CustomCheckbox id="myProfile-CommunicationPreferences-ContactBySMS-checkbox">
                    <div className="checkbox-item-label">
                      <b>
                        <Text t="sms" />
                      </b>
                      <span>
                        <Text t="checkboxSMS" />
                      </span>
                    </div>
                  </CustomCheckbox>
                </CustomFormItem>
              </div>
            </div>

            <div className="row ">
              <div className="col-md-12">
                <CustomFormItem
                  label={false}
                  name="contactByMail"
                  className="custom-form-item"
                  valuePropName="checked"
                >
                  <CustomCheckbox id="myProfile-CommunicationPreferences-contactByMail-checkbox">
                    <div className="checkbox-item-label">
                      <b>
                        <Text t="email" />
                      </b>
                      <span>
                        <Text t="checkboxEmail" />
                      </span>
                    </div>
                  </CustomCheckbox>
                </CustomFormItem>
              </div>
            </div>

            <div className="row ">
              <div className="col-md-12">
                <CustomFormItem
                  label={false}
                  name="contactByCall"
                  className="custom-form-item"
                  valuePropName="checked"
                >
                  <CustomCheckbox id="myProfile-CommunicationPreferences-contactByCall-checkbox">
                    <div className="checkbox-item-label">
                      <b>
                        <Text t="phoneCall" />
                      </b>
                      <span>
                        {' '}
                        <Text t="checkboxPhone" />
                      </span>
                    </div>
                  </CustomCheckbox>
                </CustomFormItem>
              </div>
            </div>

            <p className="info-text">
              <Text t="communicationPrefInfoText" />{' '}
              <a href={personalDataProtectionLaw} target="_blank" rel="noreferrer">
                <Text t="communicationPrefInfoText2" />
              </a>
            </p>
            <CustomFormItem className="custom-form-footer">
              <CustomButton id="myProfile-CommunicationPreferences-custom-btn-cancel" className="custom-btn-cancel" onClick={onCancel}>
                <span className="submit">
                  <Text t="giveUp" />
                </span>
              </CustomButton>
              <CustomButton id="myProfile-CommunicationPreferences-custom-btn-primary" className="custom-btn-primary" type="primary" htmlType="submit">
                <span className="submit">
                  <Text t="saveBtn" />
                </span>
              </CustomButton>
            </CustomFormItem>
          </CustomForm>
        </div>
      </div>
    </div>
  );
};

export default CommunicationPreferences;
